import { render, staticRenderFns } from "./TimeZoneFormatter.vue?vue&type=template&id=34b4c8c0&"
import script from "./TimeZoneFormatter.vue?vue&type=script&lang=js&"
export * from "./TimeZoneFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports